import dayjs from "dayjs"

const FINANCIAL_YEARS_SHOWN = 3

// Quick ranges for every admin DateRangePicker (pass as its `ranges` prop): the latest three financial
// years (April to March), then the usual day, week, month and calendar-year ranges. Weeks start on Sunday
// like the calendar. Pass allowFuture: false for pickers that disable future dates, so a range that has
// not finished yet stops at today instead of being unusable.
export const getPredefinedDateRanges = ({ allowFuture = true } = {}) => {
  const today = dayjs()
  const financialYearStart = today.month() < 3 ? today.year() - 1 : today.year()

  const financialYears = Array.from({ length: FINANCIAL_YEARS_SHOWN }, (_, index) => {
    const start = financialYearStart - index
    return { label: `FY ${start}-${start + 1}`, value: [dayjs(`${start}-04-01`), dayjs(`${start + 1}-03-31`)] }
  })

  const lastMonth = today.subtract(1, "month")
  const ranges = [
    ...financialYears,
    { label: "Today", value: [today, today] },
    { label: "Yesterday", value: [today.subtract(1, "day"), today.subtract(1, "day")] },
    { label: "This Week", value: [today.startOf("week"), today.endOf("week")] },
    { label: "Last Week", value: [today.subtract(1, "week").startOf("week"), today.subtract(1, "week").endOf("week")] },
    { label: "This Month", value: [today.startOf("month"), today.endOf("month")] },
    { label: "Last Month", value: [lastMonth.startOf("month"), lastMonth.endOf("month")] },
    { label: "This Year", value: [today.startOf("year"), today.endOf("year")] },
    { label: "Last Year", value: [today.subtract(1, "year").startOf("year"), today.subtract(1, "year").endOf("year")] },
  ]

  return ranges
    .filter(({ value: [start] }) => allowFuture || !start.isAfter(today, "day"))
    .map(({ label, value: [start, end] }) => ({
      label,
      value: [start.startOf("day").toDate(), (allowFuture || !end.isAfter(today, "day") ? end : today).startOf("day").toDate()],
      placement: "left",
    }))
}
